import { render, staticRenderFns } from "./ExamineCategorySelect.vue?vue&type=template&id=27bfc6a2&scoped=true"
import script from "./ExamineCategorySelect.vue?vue&type=script&lang=js"
export * from "./ExamineCategorySelect.vue?vue&type=script&lang=js"
import style0 from "./ExamineCategorySelect.vue?vue&type=style&index=0&id=27bfc6a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bfc6a2",
  null
  
)

export default component.exports